<template>
  <van-action-sheet teleport="#app" v-model:show="isShow" :style="{ height: '80%' }" title="优惠券详情" safe-area-inset-bottom>
    <div class="content">
      <div v-show="showQR">
        <div class="showQR fhcud">
          <!-- <div class="disabled fc" v-if="datas[0].statusFlag !== 2">
            <img :src="disableImgUrl" />
          </div>
          <div v-show="datas[0].statusFlag === 2" class="fc" id="qrcode"></div> -->
          <div class="couponCode">券码 {{ datas[0].couponCode }}</div>
          <div class="time">有效期：{{ getTime(datas[0]) }}</div>
          <div>请联系店内服务顾问协助使用</div>
        </div>
        <van-cell class="useState" title="使用情况">
          <template #label>
            <div v-html="useState(datas[0])"></div>
          </template>
        </van-cell>
      </div>
      <div class="coupon" v-show="!showQR">
        <CouponList v-if="datas.length" :showArrow="false" :couponList="datas" :scene="scene" />
      </div>
      <!-- 动态折扣券，车龄配置区间段与现有不一致，先不展示 -->
      <!-- <van-cell title="动态折扣介绍" v-if="datas[0].rightTypeFlag === 11">
        <template #label>
          <div v-for="item in datas[0].rightContent.content" :key="item.id">
            车龄{{ item.carAgeMin }}{{ item.carAgeMax == 99 ? `年以上` : `~${item.carAgeMax}年` }}-享受{{ item.discount }}折扣
          </div>
        </template>
      </van-cell> -->
      <van-collapse v-model="activeNames" accordion>
        <van-collapse-item title="权益描述" name="1">
          <div v-html="datas[0].description"></div>
        </van-collapse-item>
        <van-collapse-item title="使用限制说明" name="2">
          <div v-html="datas[0].useDescription"></div>
        </van-collapse-item>
        <van-cell class="dealer" v-if="showQR" v-show="scene !== 'myRight'" title="适用经销商" :value="datas[0].dealer" />
        <van-cell class="dealer" v-if="showQR" v-show="scene === 'myRight'" title="购买经销商" :value="datas[0].dealer" />
        <div v-show="scene === 'myRight' && !isCouponBeenUsedUp && !isExperienceCoupon" @click="viewUseDealer(datas[0])" style="padding:10px 16px;">
          <span class="viewUseDealerTitleClass">可使用经销商</span>
          <span class="viewUseDealerValueClass underline">点击查看</span>
        </div>
      </van-collapse>
    </div>
  </van-action-sheet>
</template>

<script>
import { reactive, toRefs, watch, watchEffect,ref } from 'vue'
import CouponList from '@/components/plan/CouponList'
import QRCode from 'qrcodejs2'
import { onBeforeRouteLeave } from 'vue-router'
import moment from 'moment'
export default {
  props: ['datas', 'showPopUp', 'showQR', 'scene'],
  components: {
    CouponList
  },
  emits: ['viewUseDealer'],
  setup(props, { emit }) {
    let { datas, showPopUp, showQR, scene } = toRefs(props)
    const isCouponBeenUsedUp = ref(false);
    const isExperienceCoupon = ref(false);
    watchEffect(() => {
      if (datas.value) {
          const currentCouponData = datas.value[0] || {}
         // 如果卡券用完了
          isCouponBeenUsedUp.value = currentCouponData.phasedResidueUseNum === 0

          // 如果是体验券
          isExperienceCoupon.value = currentCouponData.phasedResidueUseNum === -1
      }
    });
    const state = reactive({
      isShow: false,
      datas,
      showQR,
      scene,
      showPopUp,
      activeNames: '1',
      disableImgUrl: '',
      qrcode: ''
    })
    onBeforeRouteLeave(() => {
      state.isShow = false
    })
    watch(
      () => state.showPopUp,
      () => {
        state.isShow = true
        // if (state.showQR) {
        //   let statusFlag = state.datas[0].statusFlag
        //   if (statusFlag === 2) {
        //     let URL = `?couponCode=${state.datas[0].couponCode}&from=rightsPlan`
        //     if (state.qrcode) {
        //       state.qrcode.clear() // 清除代码
        //       nextTick(() => {
        //         state.qrcode.makeCode(URL) // 生成另外一个二维码
        //       })
        //     } else {
        //       nextTick(() => {
        //         state.qrcode = new QRCode('qrcode', {
        //           width: 100,
        //           height: 100,
        //           text: URL, // 二维码地址
        //           colorDark: '#000',
        //           colorLight: '#fff'
        //         })
        //       })
        //     }
        //   } else {
        //     state.disableImgUrl = require(`../../assets/images/status${statusFlag}.png`)
        //   }
        // }
      }
    )
    let useState = item => {
      let isUse = ['', '不限制', '年', '季度', '月']
      let frequency = item.phaseTypeFlag === 1 ? '' : `，本${isUse[item.phaseTypeFlag]}可使用${item.phasedResidueUseNum}次`
      let phaseStr = item.phaseTypeFlag == 1 ? `` : `，每${item.phaseTypeName}可使用${item.phasedUseNum}次`
      let total = item.totalUseNum
      let used = item.usedNum
      return total > 0
        ? `共可使用${total}次${phaseStr} <br> 已使用${used}次，共剩余${total - used}次${frequency}`
        : !(phaseStr || frequency)
        ? '不限使用次数'
        : `${phaseStr.substring(1)}<br>${frequency.substring(1)}`
    }
    let getTime = item => {
      return item.activeStartTime + '-' + item.activeEndTime
    }
    const viewUseDealer = data => {
      emit('viewUseDealer', data)
    }
    return {
      ...toRefs(state),
      useState,
      getTime,
      moment,
      viewUseDealer,
      isCouponBeenUsedUp,
      isExperienceCoupon
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  padding: 15px 20px;
}
.viewUseDealerValueClass {
  // margin-left: 5px;
  // text-align: left !important;
  font-size: 14px;
  color: #969799;
}
.viewUseDealerTitleClass {
  // width: 200px !important;
  font-size: 14px;
  color: #323233;
  margin-right: 20px;
}
.title {
  font-size: 15px;
  font-weight: bold;
  color: #333333;
}
.content {
  font-size: 12px;
  color: #666666;
  text-align: left;
  padding: 15px 20px 60px;
}
button {
  margin-top: 28px;
}
.coupon {
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.05);
}
.showQR {
  font-size: 12px;
  color: #333333;
  padding-bottom: 16px;
  img {
    width: 100px;
    height: 100px;
  }
  .couponCode {
    margin: 10px 0 12px;
    font-weight: bold;
    font-size: 14px;
  }
  .time {
    color: #666666;
    margin-bottom: 6px;
  }
}
.useState {
  padding-top: 16px;
  border-top: 1px solid rgba(204, 204, 204, 0.23);
}
#qrcode {
  width: 100px;
  height: 100px;
  padding: 5px;
  box-shadow: 0 0 2px #666666;
  img {
    width: 100px;
    height: 100px;
  }
}
.disabled {
  width: 100px;
  height: 100px;
  background: url('../../assets/images/QRbg.png');
  background-size: 100%;
}
.dealer {
  :deep(.van-cell__value) {
    flex-basis: 50%;
  }
}
</style>
